import { render, staticRenderFns } from "./CompareRewardsBanner.vue?vue&type=template&id=9f76c018"
import script from "./CompareRewardsBanner.vue?vue&type=script&lang=js"
export * from "./CompareRewardsBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports